import { DeliveryItem } from "@omni/components/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/deliveryItem";
import { Delivery } from "@omni/components/components/Product/ECommerce/components/delivery/delivery";
import { ECommerce } from "@omni/components/components/Product/ECommerce/eCommerce";
import { useECommerceProduct } from "@omni/components/components/Product/ECommerce/hooks/useECommerceProduct.hook";
import { useGranite } from "@omni/components/redux/modules/value/translations/translations.provider";
import { ProductVisibilityType } from "@omni/types/api/product/bff/shared/enums/productVisibilityType.enum";
import { cn } from "@omni/utils/styles";

import { OrderButton } from "@/components/Product/ECommerce/components/orderButton/orderButton.container";

export const DeliveryComponent = () => {
    const { t } = useGranite();

    const { isWebOnly, hasDelivery, visibilityType } = useECommerceProduct();

    const onlyHomeDelivery = visibilityType === ProductVisibilityType.Delivery;
    const onlyAvailableInStore =
        visibilityType === ProductVisibilityType.OnlyAvailableInStore;

    return (
        <>
            <Delivery.NoDelivery />
            {onlyAvailableInStore && !isWebOnly && (
                <Delivery.OnlyAvailableInStore displayEcommerceText={true} />
            )}
            {hasDelivery && !onlyAvailableInStore && (
                <div>
                    <div className={cn("tw:flex tw:flex-col tw:mb-4")}>
                        <p className={cn("tw:w-full tw:mb-2")}>
                            {t("ecommerce.title.delivery")}
                        </p>
                        <Delivery.Types
                            className={cn(
                                "tw:w-full tw:bg-background tw:border tw:border-grey-input tw:rounded-sm"
                            )}
                        >
                            <Delivery.Types.DeliveryItem
                                className={cn(
                                    "tw:p-4 tw:not-last:border-b tw:border-grey-input"
                                )}
                            >
                                <DeliveryItem.Info
                                    className={cn("tw:flex tw:justify-between")}
                                >
                                    <DeliveryItem.Info.DeliveryCost />
                                </DeliveryItem.Info>
                                <DeliveryItem.HomeDelivery>
                                    <DeliveryItem.HomeDelivery.DeliveryPromise />
                                    <DeliveryItem.HomeDelivery.MinimumOrderQuantity />
                                    <DeliveryItem.HomeDelivery.SupplierInfoLink />
                                </DeliveryItem.HomeDelivery>
                                <DeliveryItem.ClickAndCollect>
                                    <DeliveryItem.ClickAndCollect.LimitedStock />
                                    <DeliveryItem.ClickAndCollect.BoxPromise />
                                    <DeliveryItem.ClickAndCollect.NoStore />
                                    <DeliveryItem.ClickAndCollect.ItemStock />
                                    <DeliveryItem.ClickAndCollect.StorePickerButton />
                                </DeliveryItem.ClickAndCollect>
                                <DeliveryItem.AdditionalServices>
                                    <DeliveryItem.AdditionalServices.Item />
                                </DeliveryItem.AdditionalServices>
                            </Delivery.Types.DeliveryItem>
                        </Delivery.Types>
                    </div>
                    {onlyHomeDelivery && !isWebOnly && (
                        <div className={cn("tw:mb-4")}>
                            <Delivery.OnlyAvailableInStore
                                displayEcommerceText={false}
                            />
                        </div>
                    )}
                    <Delivery.ProductConfiguration className={cn("tw:mb-4")} />
                    <div className={cn("tw:flex tw:flex-col")}>
                        <p className={cn("tw:w-full tw:mb-2")}>
                            {t("ecommerce.label.amount")}
                        </p>
                        <div
                            className={cn(
                                "tw:flex tw:mb-2 tw:justify-between tw:items-center"
                            )}
                        >
                            <div className={cn("tw:min-w-26 tw:md:w-auto")}>
                                <Delivery.Amount />
                            </div>
                            <ECommerce.WishlistButton />
                        </div>
                        <OrderButton />
                    </div>
                </div>
            )}
        </>
    );
};
